import { ApplicationState } from "../index";

export const getContentFromStore = (state: ApplicationState) => state.content;
export const getContentApiDataFromStore = (state: ApplicationState) =>
  state.contentApiData;
export const getPartnerPlaylistsDataFromStore = (state: ApplicationState) =>
  state.content.partnersPlaylistData;
